import { render } from "./DatePickerSidebar.vue?vue&type=template&id=01b9e206&scoped=true"
import script from "./DatePickerSidebar.vue?vue&type=script&lang=js"
export * from "./DatePickerSidebar.vue?vue&type=script&lang=js"

import "./DatePickerSidebar.vue?vue&type=style&index=0&id=01b9e206&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b9e206"]])

export default __exports__